<template>
  <v-dialog
    v-model="dialog"
    max-width="650px"
  >
    <v-card
      :loading="settlementDeleteProcessing"
    >
      <v-card-title class="headline">
        {{ dialogTitle }}
      </v-card-title>
      <v-card-text class="pt-10">
        <p>{{ dialogMessage }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          :disabled="settlementDeleteProcessing"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="red"
          text
          :disabled="settlementDeleteProcessing"
          @click="confirmDeleteSettlement"
        >
          Delete Settlement
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DeleteSettlementDialog',
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    deleteSettlementEndpoint: {
      type: String,
      required: true,
    },
    dialogMessage: {
      type: String,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
  },
  emits: ['close-dialog'],
  data() {
    return {
      settlementDeleteProcessing: false,
      dialog: true,
    };
  },
  methods: {
    ...mapActions('notification', ['setNotification']),
    ...mapActions('settlement', ['deleteSettlementPlan', 'initializeSettlement']),

    close() {
      this.dialog = false;
      this.$emit('close-dialog');
    },
    async confirmDeleteSettlement() {
      this.settlementDeleteProcessing = true;

      try {
        const result = await this.deleteSettlementPlan({
          settlementDeleteEndpoint: this.deleteSettlementEndpoint,
        });

        this.settlementDeleteProcessing = false;

        if (result.status === 200) {
          const msg = 'Delete Settlement was completed';
          this.setNotification({
            message: msg,
            color: 'green',
          });

          this.initializeSettlement({
            ticketId: this.ticket.crm.id,
            lpLoan: this.ticket.active_loan.id,
          });
          this.close();
        }
      } catch (e) {
        const msg = 'There was an error processing your request';
        this.setNotification({
          message: msg,
          color: 'red',
        });
        this.settlementDeleteProcessing = false;
        this.close();
      }
    },
  },
};
</script>
